
const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#000',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

module.exports.reportData = {
  info: {
    campaignName: 'ASPYN NEUTROGENA 2017',
    influencerName: 'Aspyn Ovard',
    reportDate: new Date('2017-12-05'),
    hasLogo: false,
  },
  youtubeViews: 1855832,
  youtubeEngagements: 172168,
  supportingActivity: [
    {
      platform: 'instagram',
      title: 'So excited to be partnering with @neutrogena to bring you guys an awesome giveaway! ',
      views: 1334912,
      engagements: 113821,
      url: 'https://www.instagram.com/p/BXyQyNfAEq7',
      screenshot: '/images/screenshots/example-instagram.jpeg',
    },
    {
      platform: 'instagram',
      title: 'Anti-Aging Moisturiser',
      views: 919281,
      engagements: 81471,
      url: 'https://www.instagram.com/p/BcIgp7Gl9xS',
      screenshot: '/images/screenshots/example-instagram.jpeg',
    },
    {
      platform: 'twitter',
      url: 'https://twitter.com/aspynovard/status/55830477248020480',
      title: 'ive been liking my Neutrogena Healthy Skin Enhancer way more that my MUFE Hd Foundation!',
      views: 65216,
      engagements: 2086,
      screenshot: '/images/screenshots/callux-snickers-tweet-redacted.jpeg',
    },
    {
      platform: 'twitter',
      url: 'https://twitter.com/AspynOvard/status/936334423947169792',
      title: 'My #neutrogena challenge is almost complete! It feels nice to be in a routine again! ',
      views: 65216,
      engagements: 2086,
      screenshot: '/images/screenshots/callux-snickers-tweet-redacted.jpeg',
    },
    {
      platform: 'snapchat',
      title: 'SNAP 1 - start of day',
      views: 65216,
      screenshot: '/images/screenshots/snapchat.png',
    },
    {
      platform: 'snapchat',
      title: 'SNAP 2 - bedtime',
      views: 34567,
      screenshot: '/images/screenshots/snapchat.png',
    },
  ],
  heroData: {
    main: {
      title: 'REAL Married Morning Routine 2017! | Aspyn Ovard',
      subTitle: 'Hi guys! Today my husband Parker and I are partnering with Neutrogena and showing you our REAL married morning routine 2017!',
      videoUrl: 'https://www.youtube.com/watch?v=5oKKMqRwssc',
      views: 1855832,
      engagements: 172168,
      watchTimeUKIre: 5134960,
      watchTimeTotal: 9960701,
      donutData: {
        labels: [
          'female %',
          'male %',
        ],
        datasets: [{
          data: [88.6, 11.4],
          backgroundColor: [
            dyzioPalette.bgPink,
            dyzioPalette.bgGreen,
          ],
          borderColor: [
            dyzioPalette.pink,
            dyzioPalette.green,
          ],
          borderWidth: 1,
        }],
      },
      barData: {
        labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '64+'],
        datasets: [
          {
            label: 'female %',
            backgroundColor: dyzioPalette.bgPink,
            borderColor: dyzioPalette.pink,
            borderWidth: 1,
            data: [10.3, 35.7, 26.6, 8.3, 5.5, 1, 1.3],
          },
          {
            label: 'male %',
            backgroundColor: dyzioPalette.bgGreen,
            borderColor: dyzioPalette.green,
            borderWidth: 1,
            data: [1.7, 4.6, 2.4, 1.3, 1, 0.2, 0.2],
          },
        ],
      },
      viewingData: [{
          name: 'United Kingdom',
          watchTime: 4851821,
          views: 1482325,
        },
        {
          name: 'United States',
          watchTime: 685318,
          views: 231356,
        },
        {
          name: 'Mexico',
          watchTime: 301782,
          views: 125655,
        },
        {
          name: 'Australia',
          watchTime: 403189,
          views: 122285,
        },
        {
          name: 'Ireland',
          watchTime: 297579,
          views: 95501,
        },
      ],
    },
    supportingData: {
      labels: [
        'instagram',
        'twitter',
        'snapchat',
      ],
      datasets: [{
        data: [2169222, 130434, 99777],
        backgroundColor: [
          dyzioPalette.bgPink,
          dyzioPalette.blue,
          dyzioPalette.amber,
        ],
        borderColor: [
          dyzioPalette.pink,
          dyzioPalette.bgBlue,
          dyzioPalette.bgAmber,
        ],
        borderWidth: 1,
      }],
    },
  },
};



// WEBPACK FOOTER //
// ./src/containers/campaign-report/data/aspyn-neutrogena-2017.js